export default function (text: string) {
  if (text) {
    try {
      const parsed = Number(text) * 100;
      return `${Number(parsed).toFixed(2)}%`;
    } catch (e) {
      return "0 %";
    }
  } else {
    return "0 %";
  }
}
